import styled from "styled-components";
import { NavLink as RouterNavLink } from "react-router-dom";
import { Link } from "react-router-dom";

export const StyledMenu = styled.menu`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  margin: 0;
  border-radius: 40px;
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: ${({ theme }) => theme.shadow.small};

  @media (max-width: 520px) {
    padding: 15px 20px;
  }
`;

export const LogoFlex = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const LogoLink = styled(Link)`
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  &.active {
    color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 660px) {
    font-size: 0.75rem;
  }
`;

export const Nav = styled.nav`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 1300px) {
    gap: ${({ theme }) => theme.spacing.small};
  }

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const NavMobile = styled.nav`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.small};
  justify-content: center;
`;

export const NavLink = styled(RouterNavLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.text};
  background-color: transparent;
  font-weight: 500;
  padding: ${({ theme }) => theme.padding.button};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  transition: color 0.3s, background-color 0.3s;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.navLink};
  }

  &.active {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.navLink};
  }
`;

export const NavLinkBox = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
  justify-self: center;
  width: 140px;
  overflow: visible;
`;

export const UserBlock = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const UserManagement = styled.div`
  display: flex;
  gap: inherit;

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const User = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 520px) {
    display: none;
  }
`;

export const UserName = styled.p`
  margin: 0;
  font-weight: 500;

  @media (max-width: 660px) {
    font-size: 0.75rem;
  }
`;

export const UserRole = styled.p`
  margin: 0;
  font-size: 0.75rem;

  @media (max-width: 660px) {
    font-size: 0.6rem;
  }
`;

export const MobileMenuButton = styled.div`
  display: none;

  @media (max-width: 1100px) {
    display: flex;
  }
`;
